
export const dayList = [
  { en: 'Mon', th: 'จ.' },
  { en: 'Tue', th: 'อ.' },
  { en: 'Wed', th: 'พ.' },
  { en: 'Thu', th: 'พฤ.' },
  { en: 'Fri', th: 'ศ.' },
  { en: 'Sat', th: 'ส.' },
  { en: 'Sun', th: 'อา' }
];

export const monthList = [
  { en: 'Jan', th: 'ม.ค.' },
  { en: 'Feb', th: 'ก.พ.' },
  { en: 'Mar', th: 'มี.ค.' },
  { en: 'Apr', th: 'เม.ย.' },
  { en: 'May', th: 'พ.ค.' },
  { en: 'Jun', th: 'มิ.ย.' },
  { en: 'Jul', th: 'ก.ค.' },
  { en: 'Aug', th: 'ส.ค.' },
  { en: 'Sep', th: 'ก.ย.' },
  { en: 'Oct', th: 'ต.ค.' },
  { en: 'Nov', th: 'พ.ย.' },
  { en: 'Dec', th: 'ธ.ค' }
];

export const paymentTypes = [
  { label: 'เงินสด', value: '0' },
  { label: 'เครดิต 30 วัน', value: '30' },
  { label: 'เครดิต 45 วัน', value: '45' },
  { label: 'เครดิต 60 วัน', value: '60' }
];

export const transactionStatus = [
  { value: 'CREATED', label: 'อยู่ระหว่างดำเนินงาน' },
  { value: 'COMPLETED', label: 'สำเร็จ' },
  { value: 'CANCLED', label: 'ยกเลิก' },
];